import content from "../data/content.json";

const translationMap = content.reduce((acc, item) => {
  acc[item.from] = item.to;
  return acc;
}, {});

export function t(key) {
  return translationMap[key] || key;
}
